import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import axios from "axios";
import Top from "./screens/Top";
import NoMatch from "./screens/NoMatch";
const App = () => {
  const [companies, setCompanies] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const key = {
      headers: { "X-MICROCMS-API-KEY": process.env.REACT_APP_API_KEY },
    };
    axios
      .get("https://tekisyoku.microcms.io/api/v1/companies/?limit=50", key)
      .then((res) => {
        setCompanies(res.data);
        setLoading(false);
      })
      .catch(setLoading(true));
  }, []);

  // console.log(companies);
  // aconst [pass, setPass] = useState();

  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path="/"
            render={() => <Top companies={companies} loading={loading} />}
          />
          <Route exact path="*" render={() => <NoMatch />} />
        </Switch>
      </BrowserRouter>
    </>
  );
};

export default App;
